import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { Site } from '../types';
import { getDataStore } from './genericSelectors';

export const selectSites = (state: any) => getDataStore(state).site.items;

export const selectSiteItems = createSelector(
  [selectSites],
  sites => {
    return Object.keys(sites).map(k => sites[Number(k)]);
  }
);

export const selectSitesForWorkgroups = createSelector(
  [selectSiteItems],
  (sites: Site[]) =>
    memoizeOne((workgroupIds: number[]) =>
      sites.filter(site => workgroupIds.indexOf(site.workgroupId) !== -1)
    )
);
